export default __webpack_public_path__ + "static/media/analytics.580ede74.svg";